export default __webpack_public_path__ + "static/media/newPc.b6a3f041.svg";